import { render } from "./AddShippingMethod.vue?vue&type=template&id=cefd7e6a&ts=true"
import script from "./AddShippingMethod.vue?vue&type=script&lang=ts"
export * from "./AddShippingMethod.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__